import React from "react";
import { Search, ChevronDown, X } from "lucide-react";

export default function SorteosFiltrosComponents({
  searchValue,
  onSearchChange,
  vigenciaPublicacionFilter,
  onVigenciaPublicacionChange,
  vigenciaPublicacionOptions = [],
  vigenciaPromocionFilter,
  onVigenciaPromocionChange,
  vigenciaPromocionOptions = []
}) {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 mb-6 flex flex-col lg:flex-row lg:items-end gap-4">
      <div className="flex-1">
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          Buscar
        </label>
        <div className="relative w-full lg:flex-1">
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
            <Search className="w-5 h-5" />
          </span>
          <input
            type="text"
            placeholder="Ingresar razón social, RUC o nombre de fantasía"
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10 pr-3 py-2 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm w-full focus:outline-none focus:ring-2 focus:ring-blue-200"
          />

          {searchValue && (
            <button
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              onClick={() => onSearchChange("")}
            >
              <X className="w-5 h-5" />
            </button>
          )}
        </div>

      </div>


      <div>
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          Vigencia de la Publicación
        </label>

        <div className="relative w-full sm:w-64">
          <select
            value={vigenciaPublicacionFilter}
            onChange={(e) => onVigenciaPublicacionChange(e.target.value)}
            className="appearance-none w-full px-3 py-2 pr-8 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
          >
            {vigenciaPublicacionOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {`Publicación: ${option.label}`}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
        </div>
      </div>


      <div>
        <label className="mb-1.5 block text-sm font-semibold text-gray-700">
          Vigencia de la Promoción
        </label>
        <div className="relative w-full sm:w-64">
          <select
            value={vigenciaPromocionFilter}
            onChange={(e) => onVigenciaPromocionChange(e.target.value)}
            className="appearance-none w-full px-3 py-2 pr-8 rounded-lg bg-[#f1f5f9] border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 cursor-pointer"
          >
            {vigenciaPromocionOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {`Promoción: ${option.label}`}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
        </div>
      </div>
    </div>
  );
}
